<template>
	<section class="resource-section-row">
		<div class="b360-container-row">
			<h1>{{ header }}</h1>
			<section :class="`description-row-content ${className}`">
				<p class="description">{{ subheader }}</p>
				<router-link
					tag="button"
					:to="`/campaign-editor-home/campaign-editor-${className}`"
					:class="`view-all-btn ${className}`"
					>View All</router-link
				>
			</section>
		</div>
		<section class="resource-content-row">
			<swiper-container
				class="swiper-container"
				:class="{ 'allow-footer': allowFooter }"
				:slides-per-view="'auto'"
				:space-between="60"
				:centered-slides="false"
				:free-mode="true"
				:navigation="true"
			>
				<swiper-slide
					v-for="item in content"
					:key="item.id"
					class="swiper-slide"
				>
					<CampaignCard :item="item" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<ViewAllCard
						:linkLocation="`/campaign-editor-home/campaign-editor-${className}`"
					/>
				</swiper-slide>
			</swiper-container>
		</section>
	</section>
</template>

<script>
import CampaignCard from '@/components/cards/CampaignCard.vue';
import ViewAllCard from '@/components/cards/ViewAllCard.vue';

export default {
	name: 'CampaignSectionRow',
	components: {
		CampaignCard,
		ViewAllCard,
	},
	props: {
		header: String,
		subheader: String,
		content: Array,
		className: String,
		allowFooter: Boolean,
	},
};
</script>

<style lang="scss" scoped>
/deep/ .allow-footer.swiper-container {
	margin-bottom: unset;
}

h1 {
	margin-bottom: unset;
}

section.resource-section-row {
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: $off-white;
}

section.resource-section-row:first-child {
	border-bottom: 1px solid $border-color-light;
}

.description-row-content {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	@include rem(margin-bottom, 30px);

	&:not(.whats-new) {
		margin-top: -25px;
		@include mobile {
			margin-top: unset;
		}
	}

	p.description {
		@include rem(max-width, 1050px);
		@include rem(width, 100%);
		@include rem(margin, 20px 0 0);
		@include rem(font-size, 15px);
	}

	button.view-all-btn {
		padding: 12px 15px;
		background-color: $white;
		border: $b360-border-width-thin solid $border-color-light;
		border-radius: $b360-border-radius-base;
		color: $brand-blue;
		font-family: 'Roboto Medium';
		@include rem(font-size, 15px);
		cursor: pointer;
		z-index: 2;
		@include typo--roboto__medium;
		@include mobile {
			display: none;
		}
	}
}

.swiper-container {
	padding: 0 30px;
}

.swiper-slide {
	width: 200px;
}

swiper-container::part(button-next),
swiper-container::part(button-prev) {
	background-color: white;
	width: 45px;
	height: 45px;
	border-radius: 5px;
	padding: 10px;
	box-sizing: border-box;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
	top: 100px;
}
</style>
